<app-dialog
  customClass="edit-tax"
  [headerLabel]="dialogHeader"
  [primaryActionText]="'ACTION.SAVE' | translate"
  [primaryActionDisabled]="!form?.valid"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="saveAction"
  [primaryActionTrackingAdditionalProperties]="editTaxAdditionalProperties"
  [dismissActionTapped]="dismissAction"
  [dismissActionTrackingAdditionalProperties]="editTaxAdditionalProperties"
  (onPrimaryAction)="onSave()"
>
  <div id="edit-tax-dialog">
    <app-form-master
      *ngIf="form"
      [form]="form"
      (formChanges)="updateTrackingProperties($event)"
      class="form-content"
    >
      <p class="info-text">
        {{ 'DIALOG.EDIT_TAX.INFO_TEXT' | translate }}
      </p>

      <div class="form-row tax-type-wrapper">
        <span class="field-label">
          {{ 'DIALOG.EDIT_TAX.TAX_CALCULATION' | translate }}
        </span>

        <app-value-switch-field
          fieldId="tax_type_field"
          [switches]="taxTypes"
          [description]="'DIALOG.EDIT_TAX.TAX_TYPE_DESCRIPTION' | translate"
          [formControl]="form.get(formKeys.INCLUSIVE)"
        >
        </app-value-switch-field>
      </div>

      <div class="form-row">
        <span class="field-label">
          {{ 'DIALOG.EDIT_TAX.TAX_RATES' | translate }}
        </span>

        <div
          *ngFor="
            let formControl of ratesFormArray.controls;
            let pos = index;
            trackBy: index
          "
          class="rate-percentage-field-wrapper"
        >
          <app-percentage-field
            [label]="'DIALOG.EDIT_TAX.RATE_N' | translate: { value: pos + 1 }"
            fieldId="tax_rate_{{ pos }}_field"
            class="rate-percentage-field"
            [condensed]="true"
            [formControl]="formControl"
            [locale]="locale"
            [decimalDigits]="3"
          >
          </app-percentage-field>

          <button
            *ngIf="pos > initialRatesSize - 1"
            type="button"
            class="delete-action"
            (click)="deleteRate(pos)"
          >
            <app-icon [icon]="deleteIcon"></app-icon>
          </button>
        </div>

        <div class="add-rate-wrapper">
          <button
            type="button"
            class="add-rate-action"
            [disabled]="isAtTaxRateLimit()"
            (click)="addRateField()"
          >
            {{ 'ACTION.ADD_NEW_RATE' | translate }}
          </button>
        </div>
      </div>

      <p class="footer-note">
        {{ 'DIALOG.EDIT_TAX.FOOTER_NOTE' | translate }}
      </p>
    </app-form-master>
  </div>
</app-dialog>
